<h1 mat-dialog-title>
  {{ injectData.dialogTitle }}
</h1>
<form #form="ngForm" [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
  <div mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.name' | translate }}</mat-label>
        <input matInput [formControl]="addEditForm.controls.name" />
        <mat-error [control]="addEditForm.controls.name"></mat-error>
      </mat-form-field>
      <div class="col-12">
        <mat-dropdown
          [configurationInput]="formDropdownSettings"
          [options]="store.forms()"
          [formControl]="addEditForm.controls.form"
          [isLoading]="store.areFormsLoading()"
          [isFormSubmitted]="form.submitted"
        >
        </mat-dropdown>
      </div>
      <div class="col-12">
        <app-form-autofill-mapping
          [formControl]="addEditForm.controls.formAutofillMappings"
          [isFormSubmitted]="form.submitted"
          [formFields]="store.formFields()"
          [widgetRequests]="store.widgetRequests()"
          [selectedFormId]="$any(addEditForm.controls.form.value)[0]?.id"
        ></app-form-autofill-mapping>
      </div>

      <div class="mb-3">
        <span class="dialog-section"
          ><mat-icon class="material-icons-outlined">groups</mat-icon>
          {{ 'system.dialogSection.accessAndPermissions' | translate }}</span
        >
      </div>

      <div class="col-12">
        <mat-dropdown
          [configurationInput]="restrictAccessByDropdownSettings"
          [options]="restrictAccessByDropdownOptions"
          [formControl]="addEditForm.controls.restrictAccessBy"
          [isFormSubmitted]="form.submitted"
        >
        </mat-dropdown>
      </div>

      @if (addEditForm.controls.restrictAccessBy.value.length) {
        @switch (addEditForm.controls.restrictAccessBy.value[0].id) {
          @case (ERestrictAccessBy.dashboard) {
            <div class="col-12">
              <mat-dropdown
                [configurationInput]="dashboardDropdownSettings"
                [options]="store.dashboards()"
                [formControl]="addEditForm.controls.dashboardId"
                [isLoading]="store.areDashboardsLoading()"
                [isFormSubmitted]="form.submitted"
                (search)="dashboardSearch.next($event)"
              >
              </mat-dropdown>
            </div>
          }

          @case (ERestrictAccessBy.workspace) {
            <div class="col-12">
              <mat-dropdown
                [configurationInput]="workspaceDropdownSettings"
                [options]="store.workspaces()"
                [formControl]="addEditForm.controls.workspaceId"
                [isLoading]="store.areWorkspacesLoading()"
                [isFormSubmitted]="form.submitted"
                (search)="workspaceSearch.next($event)"
              >
              </mat-dropdown>
            </div>
          }
        }
      }
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit">
      {{ injectData.submitButtonText }}
    </button>
  </mat-dialog-actions>
</form>
